module.exports = __webpack_public_path__ + "media/images/font/SofiaProLight-d9aa34f3c71d4ce6ccdbb20ed28f3c5b.ttf";